// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"5967cbf2","14":"a24d9384","44":"c1ed3d21","125":"8e622b5a","238":"405448ee","428":"c416d9b9","683":"55dc2632","783":"5b3fe3e0","823":"94625f10","844":"5b76a0ca","885":"d577072f","903":"bf5ca8ba","962":"f32040e5"}[chunkId] + ".chunk.js";
};